import React from 'react'
import loadable from 'loadable-components';
import Loader from '../components/presentationals/Loader/Loader.component'
// website
export const LoginContainer = React.lazy(() => import('../components/containers/Admin/Login.container'));


export const Home = React.lazy(() => import('./Home.layout'))



export const AdminLogin = React.lazy(() => import('../components/containers/Admin/Login.container'))

export const Feedback = React.lazy(() => import('../components/containers/Admin/CustomerPages/UserFeedback.container'))

export const UPLOAD_DOCUMENT = React.lazy(() => import('../components/containers/Admin/UploadDocumetntNew.js'))


export const ENACHPAGE = React.lazy(() => import('../components/containers/Home/Enach.container'))

export const ESIGNPAGE = React.lazy(() => import('../components/containers/Home/NewEsign.container'))
export const Reference = React.lazy(() => import('../components/containers/Forms/UserReference.container'))

export const EsignMobile = React.lazy(() => import('../components/containers/Home/EsignIfram.container'))
export const EnachMobile = React.lazy(() => import('../components/containers/Home/EnachIframe.container'))



export const EnachCardPage = React.lazy(() => import('../components/containers/Admin/CardsUtility/CardEnach And Esign/Enach.container'))
export const EsignCardPage = React.lazy(() => import('../components/containers/Admin/CardsUtility/CardEnach And Esign/NewEsign.container'))

export const KYC_FORM = React.lazy(() => import('../components/containers/Home/kycForm'))
export const KYC_FORM_SIGNZY = React.lazy(() => import('../components/containers/Home/kycFormSignzy'))
export const KYC_REDIRECT_URL = React.lazy(() => import('../components/containers/Home/KYCRedirectPage'))
export const KYC_MOBILE = React.lazy(() => import('../components/containers/Home/kycMobile'))

export const DIGILOCKER_KYC = React.lazy(() => import('../components/containers/Home/digilockerkyc.js'))
export const KFS_PAGE = React.lazy(()=>import('../components/containers/Home/Kfsnew.js'))
export const FI_VERIFICATION = React.lazy(()=>import('../components/containers/Home/FiVerification.js'))
export const ESIGN_REDIRECT_URL = React.lazy(()=>import('../components/containers/Home/EsignRedirectPage.js'))
export const DO_LETTER = React.lazy(()=>import('../components/containers/Home/DOLetter.js'))
export const VIDEO_KYC = React.lazy(()=>import('../components/containers/Home/VideoKyc.js'))
export const VIDEO_KYC_REDIRECT = React.lazy(()=>import('../components/containers/Home/VideoKyRedirect.js'))
export const LOAN_CALCULATOR_SITE = React.lazy(()=>import('../components/containers/Home/LoanCalculator.js'))
export const ENACH_WITH_ZIPNACH = React.lazy(()=>import('../components/containers/Home/EnachZipNach.container'))